import { KeyRound, LogOut, UserPen } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { Avatar, Btn, Card, Field, Page, Section } from "../components/wf";
import { api, ROLE_LABELS, saveToken } from "../lib/api";
import { useAuth } from "../lib/auth";
import { DueSoon, WeekRecap } from "./MyWork";

export default function Profile() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [pw, setPw] = useState({ current: "", next: "", confirm: "" });
  const [saving, setSaving] = useState(false);
  const change = async () => {
    if (pw.next.length < 6) return toast.error("New password must be at least 6 characters");
    if (pw.next !== pw.confirm) return toast.error("New passwords don't match");
    setSaving(true);
    try {
      const res = await api("/auth/change-password", { method: "POST", body: { current_password: pw.current, new_password: pw.next } });
      if (res.access_token) saveToken(res.access_token, res.refresh_token, res.media_token);
      setPw({ current: "", next: "", confirm: "" });
      toast.success("Password changed");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSaving(false);
    }
  };
  return (
    <Page title="My Profile" testid="profile-page">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div className="min-w-0">
          <Card className="flex items-center gap-4">
            <Avatar name={user?.name} size={56} />
            <div className="min-w-0 flex-1">
              <p className="text-lg font-bold" data-testid="profile-name">{user?.name}</p>
              <p className="truncate text-sm text-wf-mute">{user?.email}</p>
            </div>
            <span data-testid="profile-role" className="rounded-full bg-wf-soft px-3 py-1 text-xs font-bold text-wf-softink">{ROLE_LABELS[user?.role]}</span>
          </Card>
          {user?.employee_id && <Btn variant="secondary" icon={UserPen} className="mt-3" onClick={() => nav(`/employees/${user.employee_id}`)} data-testid="profile-edit-team">Edit my team profile</Btn>}
          <div className="mt-6 flex flex-col gap-4"><WeekRecap /><DueSoon /></div>
        </div>
        <div>
          <Section title="Change Password" />
          <Field label="Current Password" type="password" testid="profile-current-password" value={pw.current} onChange={(v) => setPw((p) => ({ ...p, current: v }))} />
          <Field label="New Password" type="password" testid="profile-new-password" value={pw.next} onChange={(v) => setPw((p) => ({ ...p, next: v }))} placeholder="At least 6 characters" />
          <Field label="Confirm New Password" type="password" testid="profile-confirm-password" value={pw.confirm} onChange={(v) => setPw((p) => ({ ...p, confirm: v }))} />
          <Btn icon={KeyRound} loading={saving} disabled={!pw.current || !pw.next} onClick={change} data-testid="profile-change-password-button">Change Password</Btn>
          <div className="mt-10"><Btn variant="danger" icon={LogOut} onClick={logout} data-testid="profile-logout-button">Log Out</Btn></div>
        </div>
      </div>
    </Page>
  );
}
